export default function ignoreLocalstorage(error) {
  const localStorageMessage = `Failed to read the 'localStorage' property from 'Window': Access is denied for this document.`;
  if (typeof error === 'string' && error.includes(localStorageMessage)) return true;
  return error instanceof Error && error.message.toString().includes(localStorageMessage);
}
